import { FC } from "react";
import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";
import {
  SettingsIntegrationPageWrapper,
  SettingsIntegrationHeader,
  SettingsIntegrationScrollableArea,
  SettingsIntegrationSection,
} from "@/pages/settings/components/settings-integration-layout";
import {
  CustomVocabularySettings,
  SmartFormattingSettings,
} from "@/pages/settings/components/voice-mode";

export const SettingsVoiceModePage: FC = observer(() => {
  return (
    <SettingsIntegrationPageWrapper>
      <SettingsIntegrationHeader breadcrumb="General" title="Voice mode" />
      <SettingsIntegrationScrollableArea>
        <SettingsIntegrationSection>
          <CustomVocabularySettings />
          <Divider />
          <SmartFormattingSettings />
        </SettingsIntegrationSection>
      </SettingsIntegrationScrollableArea>
    </SettingsIntegrationPageWrapper>
  );
});

const Divider = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.border.default};
  margin: ${({ theme }) => `${theme.spacing[4]} 0`};
`;
